export const DEFAULT = '#d9d9d9';
export const SUCCESS = '#4CAF50';
export const FAIL = '#f44336';

export const CLICKED = '#4c67db';
export const NOT_CLICKED = '#4C67db4d';
